// mockScenarios.js
//
// Hardcoded step data for the /blast-test animation prototype. Deliberately
// NOT wired into useBlastHandGenerator / real CSVs yet — per plan, dial in
// the timing/feel here first, then swap to real range data once it's right.
//
// Pattern A: hero (SB) opens, villain (BB) 3-bets, hero decides.
// Mirrors the exact HU 15bb "SB Open, call vs BB 3bet Small" mockup screens.

export const SB_OPEN_VS_BB_3BET_SMALL = {
  format: 'hu',
  heroPosition: 'SB',
  villainPosition: 'BB',
  startingStack: 15,
  rangeTitle: 'SB Open, Call vs BB 3bet Small | 15bb',
  // Blinds already posted before the sequence starts — SB 0.5, BB 1 — so the
  // very first frame (before any tap) shows 14.5 / 14 remaining, not 15/15
  // and not 0 bet. This was missing before: the hook defaulted both to 0,
  // which meant the first render already looked like the raise had happened.
  startingBets: { hero: 0.5, villain: 1 },
  steps: [
    {
      type: 'lockedAction',
      actor: 'hero',
      buttonLabel: 'Open Raise',
      buttonClassName: 'blast-raise-button',
      questionText: 'You Open Raise your hand from the SB.',
      resultBet: 3,
      resultActive: 'villain',
    },
    {
      type: 'reveal',
      actor: 'villain',
      label: 'BB 3-Bets',
      resultBet: 6,
      resultActive: 'hero',
    },
    {
      type: 'decision',
      question: 'On a 15bb stack, what frequency are you calling?',
      buttons: [
        { text: '100%', buttonLargeClassName: 'blast-call-hundred-button' },
        { text: '50%', buttonLargeClassName: 'blast-limp-fifty-button' },
        { text: 'Never', buttonLargeClassName: 'blast-never-button' },
      ],
    },
  ],
};

export default SB_OPEN_VS_BB_3BET_SMALL;
